export default {
  namespace: true,
  state: () => ({
    customers: {},
  }),
  mutations: {
    SET_CUSTOMERS(state, customers) {
      state.customers = customers;
    },
  },
  actions: {
    async getCustomers() {},
  },
  getters: {},
};
